import React, { PropsWithChildren, useState, useRef, useCallback } from "react";
import { Button, Menu, Box } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type MenuButtonProps = {
  title: string;
  width?: string;
}

const MenuButton = ({ title, children, width }: PropsWithChildren<MenuButtonProps>) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const isOpen = Boolean(menuAnchorEl);

  const handleOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuAnchorEl(null);
  }, []);

  return (
    <>
      <Button
        ref={buttonRef}
        variant="contained"
        onClick={handleOpenMenu}
        sx={{
          width: width || "auto",
        }}
        endIcon={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              pt: 0.5,
            }}
          >
            <KeyboardArrowDownIcon fontSize="small" />
          </Box>
        }
      >
        {title}
      </Button>

      <Menu
        anchorEl={menuAnchorEl || buttonRef.current}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            minWidth: menuAnchorEl ? `${menuAnchorEl.offsetWidth}px` : buttonRef.current ? `${buttonRef.current.offsetWidth}px` : 'auto',
            mt: 0.5
          }
        }}
      >
        {children}
      </Menu>
    </>
  );
};

export default MenuButton;